import React from 'react'

export const COLUMNS_DETALLE_POR_CONDICION_LINEA_5 = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  }
]

export const COLUMNS_DETALLE_POR_CONDICION_LINEA_5_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    width: 60,
    mantenerCase: true
  }
]
